export default function Community() {
  const values = [
    {
      icon: 'ri-team-line',
      title: 'Unity',
      description: 'We build bridges across generations, bringing together ages 5 to 70 under one culture of respect and authenticity.'
    },
    {
      icon: 'ri-flashlight-line',
      title: 'Hustle',
      description: 'Born from the grind of the Northside. Every piece represents the relentless drive to create, build, and elevate.'
    },
    {
      icon: 'ri-medal-line',
      title: 'Pride',
      description: 'Wear your roots with confidence. BillPlay is more than a brand—it\'s a statement of where you\'re from and where you\'re going.'
    }
  ];

  return (
    <section className="py-32 px-8 bg-gradient-radial from-[#1A1A1A] via-[#0F0F0F] to-[#0A0A0A]">
      <div className="max-w-[1600px] mx-auto">
        {/* Header */}
        <div className="text-center mb-20">
          <p className="text-gray-500 text-xs font-bold tracking-[0.15em] uppercase mb-4">BUILT ON</p>
          <h2 className="text-6xl md:text-7xl font-black text-white">Community Values</h2>
        </div>

        {/* Values Grid */}
        <div className="grid md:grid-cols-3 gap-8">
          {values.map((value) => (
            <div
              key={value.title}
              className="bg-[#1C1C1C] rounded-2xl p-10 hover:bg-[#222222] transition-all duration-300 group"
            >
              <div className="w-16 h-16 flex items-center justify-center mb-6">
                <i className={`${value.icon} text-6xl text-white group-hover:scale-110 transition-transform duration-300`}></i>
              </div>
              
              <h3 className="text-2xl font-black text-white mb-4">{value.title}</h3>
              
              <p className="text-sm text-gray-400 leading-relaxed">
                {value.description}
              </p>
            </div>
          ))}
        </div>

        {/* Culture Statement */}
        <div className="mt-24 text-center max-w-3xl mx-auto">
          <p className="text-2xl md:text-3xl font-bold text-white leading-relaxed">
            "This isn't just clothing. It's a representation of the culture, the confidence, and the creativity that defines us."
          </p>
          <p className="text-gray-500 mt-6 text-sm tracking-wide">— BILLPLAY APPAREL</p>
        </div>
      </div>
    </section>
  );
}